import Icon from "./IconBase.js";
const MeetLinkIcon = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.02 11V15C22.02 16.657 20.677 18 19.02 18C17.363 18 16.02 16.657 16.02 15V10H21.02C21.5725 10 22.02 10.4475 22.02 11ZM19.02 8C20.1245 8 21.02 7.1045 21.02 6C21.02 4.8955 20.1245 4 19.02 4C17.9155 4 17.02 4.8955 17.02 6C17.02 7.1045 17.9155 8 19.02 8Z"
          fill="#5059C9"
        />
        <path
          d="M17.52 11V16.5C17.52 19.3715 15.0995 21.678 12.187 21.489C9.52952 21.317 7.52002 18.9915 7.52002 16.3285V10H16.52C17.0725 10 17.52 10.4475 17.52 11ZM12.52 8.5C14.177 8.5 15.52 7.157 15.52 5.5C15.52 3.843 14.177 2.5 12.52 2.5C10.863 2.5 9.52002 3.843 9.52002 5.5C9.52002 7.157 10.863 8.5 12.52 8.5Z"
          fill="#7B83EB"
        />
        <path
          d="M12.52 8.5C14.1769 8.5 15.52 7.15685 15.52 5.5C15.52 3.84315 14.1769 2.5 12.52 2.5C10.8632 2.5 9.52002 3.84315 9.52002 5.5C9.52002 7.15685 10.8632 8.5 12.52 8.5Z"
          fill="#7B83EB"
        />
        <path
          opacity="0.05"
          d="M13.02 16.6595V10H7.52002V16.3285C7.52002 17.0955 7.69152 17.8325 7.99202 18.5H11.179C12.196 18.5 13.02 17.676 13.02 16.6595Z"
          fill="black"
        />
        <path
          opacity="0.07"
          d="M7.52002 10V16.3285C7.52002 16.9085 7.62052 17.4705 7.79702 18H11.126C11.988 18 12.6865 17.3015 12.6865 16.4395V10H7.52002Z"
          fill="black"
        />
        <path
          opacity="0.09"
          d="M12.3535 10H7.52002V16.3285C7.52002 16.7295 7.57052 17.1205 7.65702 17.5H11.073C11.78 17.5 12.353 16.927 12.353 16.22L12.3535 10Z"
          fill="black"
        />
        <path
          d="M11.02 17H3.02002C2.46752 17 2.02002 16.5525 2.02002 16V8C2.02002 7.4475 2.46752 7 3.02002 7H11.02C11.5725 7 12.02 7.4475 12.02 8V16C12.02 16.5525 11.5725 17 11.02 17Z"
          fill="url(#paint0_linear_407_70932)"
        />
        <path
          d="M9.05384 9.49902H4.98584V10.359H6.50934V14.499H7.53034V10.359H9.05384V9.49902Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_407_70932"
            x1="2.34402"
            y1="7.324"
            x2="11.7215"
            y2="16.7015"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5961C3" />
            <stop offset="1" stopColor="#3A41AC" />
          </linearGradient>
        </defs>
      </svg>
    </Icon>
  );
};
export default MeetLinkIcon;
